export const checkPayloadObject = (payload) => {
  const pageItem = payload.find((item) => item.key === 'page');
  const isPageOne = pageItem?.value === 1;
  const isPageGreaterThanOne = pageItem?.value > 1;

  if (isPageGreaterThanOne) return false;

  if (isPageOne) {
    return payload.every(
      (item) =>
        item.key === 'schGroup' ||
        item.key === 'page' ||
        item.value === '' ||
        item.value === null ||
        item.value === undefined,
    );
  }

  return false;
};
